import { createGlobalStyle } from 'styled-components';
import { Theme } from '../types';

export const GlobalStyles = createGlobalStyle<{ theme: Theme }>`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
      'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
      'Noto Color Emoji';
    background-color: ${({ theme }) => theme.colors.background.primary};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  #root {
    height: 100%;
  }

  /* Tables are see-through (App's Table theme), so a pinned column, which covers the cells
     scrolling under it, paints the surface the table sits on. A container on another
     surface sets --table-surface. */
  :root {
    --table-surface: ${({ theme }) => theme.colors.background.primary};
  }
  /* A pinned cell lays its row's tint (hover, selection: --row-tint) over the surface, so
     it shades with the rest of the row. */
  .ant-table-wrapper .ant-table .ant-table-cell-fix-left,
  .ant-table-wrapper .ant-table .ant-table-cell-fix-right {
    background: linear-gradient(var(--row-tint, transparent), var(--row-tint, transparent)),
      var(--table-surface);
  }
  .ant-table-wrapper .ant-table .ant-table-tbody > tr:hover > td {
    --row-tint: rgba(255, 255, 255, 0.03);
  }
  .ant-table-wrapper .ant-table .ant-table-thead > tr > th {
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.02em;
  }
`;